import type { FundDatum } from "@/FundExplorer/types";
import type { API } from "hsl-core/FundExplorer";
import formatAsAtDate from "./formatAsAtDate";

export default function getFundValue(fund: FundDatum, prop: string) {
	const val = fund[prop as keyof FundDatum];
	switch (prop as keyof FundDatum) {
		case "fundSize": {
			if (!fund.currency) return "";
			return (val as API.FundSize)?.[fund.currency as API.Currency] ?? "";
		}
		case "fundLaunchDate": {
			return formatAsAtDate(val as string);
		}
		default:
			return val === "-" ? "" : (val as string);
	}
}
